import { useCallback, useEffect, useState } from 'react'
import 'survey-core/defaultV2.min.css'
import { StylesManager, Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
import { useParams, useNavigate } from 'react-router-dom'
import {
  getSurveyApplicationDetail,
  submitSurveyApplication,
  SurveyApplicationDetail,
} from '../../CustomController'
import 'survey-core/survey.i18n'

StylesManager.applyTheme('defaultV2')

const SurveyAnswer = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [survey, setSurvey] = useState<any>('')
    const [surveyApplication, setSurveyApplication] = useState<SurveyApplicationDetail | null>(null)
    const [isloading, setisloading] = useState(true)
    const [courseOutcome, setCourseOutcome] = useState(false)
    const [organizationOutcome, setOrganizationOutcome] = useState(false)
    const [organizationEducationPurpose, setOrganizationEducationPurpose] = useState(false)

    useEffect(() => {
        const surveyAppId = params.SurveyAppId ? Number(params.SurveyAppId) : undefined

        if (!surveyAppId) {
            setisloading(false)
            return
        }

        getSurveyApplicationDetail(surveyAppId)
            .then((detail) => {
                if (!detail) {
                    return
                }

                try {
                    const jsp = detail.surveyJson ? JSON.parse(detail.surveyJson) : ''
                    setSurvey(jsp)
                } catch (error) {
                    console.error('Survey JSON parse hatası:', error)
                    setSurvey('')
                }

                setCourseOutcome(detail.courseOutcomeIsChecked)
                setOrganizationOutcome(detail.organizationOutcomeIsChecked)
                setOrganizationEducationPurpose(detail.organizationEducationPurposeIsChecked)
                setSurveyApplication(detail)
            })
            .finally(() => {
                setisloading(false)
            })
    }, [params.SurveyAppId])

    console.log(courseOutcome)

    const Outcomes = [
        { courseOutcome: courseOutcome },
        { organizationOutcome: organizationOutcome },
        { organizationEducationPurpose: organizationEducationPurpose },
        { courseId: params.CourseId },
        { surveyApplicationId: surveyApplication?.id },
    ]

    let md = new Model(survey)
    md.locale = 'tr'
    md.focusFirstQuestionAutomatic = false

    const alertResults = useCallback(
        (sender: any) => {
            const results = JSON.stringify(sender.data)

            if (!surveyApplication) {
                return
            }

            const payload = {
                id: surveyApplication.id,
                surveyId: surveyApplication.surveyId,
                name: results,
                isCompleted: true,
            }

            submitSurveyApplication(payload).then(() => {
                //console.log(courseOutcome)
                if (courseOutcome) {
                    navigate('/CourseOutcomeSurvey', { state: Outcomes })
                } else if (organizationOutcome) {
                    navigate('/OrganizationOutcomeSurvey', { state: Outcomes })
                } else if (organizationEducationPurpose) {
                    navigate('/EducationPurposeOutcomeSurvey', { state: Outcomes })
                } else {
                    navigate('/Dashboard');
                }
            })
        },
        [surveyApplication, courseOutcome, organizationOutcome, organizationEducationPurpose]
    )

    md.onComplete.add(alertResults)

    return !isloading ? (
        <div style={{ backgroundColor: '#f3f3f3', height: '100vh' }}>
            {' '}
            <Survey model={md} locale='tr' />{' '}
        </div>
    ) : (
        <div style={{ backgroundColor: '#f3f3f3', height: '100vh' }}></div>
    )
}

export { SurveyAnswer }
